import { types as t } from 'mst-effect';
import { withFetchAllPages } from 'utils/requestHelpers/withFetchAllPages';
import { withRunInAction } from 'utils/withRunInAction';
import { ZoomLevel, LayoutMode, LOCAL_STORAGE_ZOOM_LEVEL, LOCAL_STORAGE_LAYOUT_MODE } from 'modules/InputsManager/types';

export const InputsStore = t
  .compose(
    withRunInAction(),
    t.model('InputsStore', {
      zoomLevel: t.refinement('zoom', t.number, (zoom) => zoom >= ZoomLevel.Farthest && zoom <= ZoomLevel.Closest),
      layoutMode: t.enumeration('layout', Object.values(LayoutMode)),
      visualSearchImageUrl: t.optional(t.string, ''),
    }),
    withFetchAllPages(),
  )
  .actions((self) => {
    return {
      zoomIn() {
        if (self.zoomLevel < ZoomLevel.Closest) {
          self.zoomLevel += 1;

          if (typeof localStorage !== 'undefined') {
            localStorage.setItem(LOCAL_STORAGE_ZOOM_LEVEL, self.zoomLevel.toString());
          }
        }
      },
      zoomOut() {
        if (self.zoomLevel > ZoomLevel.Farthest) {
          self.zoomLevel -= 1;

          if (typeof localStorage !== 'undefined') {
            localStorage.setItem(LOCAL_STORAGE_ZOOM_LEVEL, self.zoomLevel.toString());
          }
        }
      },
      toggleLayout() {
        self.layoutMode = self.layoutMode === LayoutMode.Grid ? LayoutMode.Masonry : LayoutMode.Grid;

        if (typeof localStorage !== 'undefined') {
          localStorage.setItem(LOCAL_STORAGE_LAYOUT_MODE, self.layoutMode);
        }
      },
      setVisualSearchImageUrl(url: string) {
        self.visualSearchImageUrl = url;
      },
    };
  });
